import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import classNames from 'classnames';
import { ACCOUNT_SETTINGS_PAGES } from '../../routeConfiguration';
import { propTypes } from '../../util/types';
import Drawer from '../Drawer/Drawer'
import fr from '../../assets/flag/fr.jpg'
import en from '../../assets/flag/en.jpg'

import {
  Avatar,
  InlineTextButton,
  Logo,
  Menu,
  MenuLabel,
  MenuContent,
  MenuItem,
  NamedLink,
} from '../../components';

import css from './TopbarDesktop.module.css';
import { Height } from '@material-ui/icons';

const TopbarDesktop = props => {
  const {
    className,
    currentUser,
    isMobileLayout,
    currentPage,
    rootClassName,
    notificationBooking,
    transactions,
    currentUserHasListings,
    notificationCount,
    intl,
    isAuthenticated,
    onLogout,
    showAddListing
  } = props;
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const authenticatedOnClientSide = mounted && isAuthenticated;
  const isAuthenticatedOrJustHydrated = isAuthenticated || !mounted;

  const classes = classNames(rootClassName || css.root, className);

  const notificationDot = notificationCount > 0 ? <div className={css.notificationDot} /> : null;

  const currentPageClass = page => {
    const isAccountSettingsPage =
      page === 'AccountSettingsPage' && ACCOUNT_SETTINGS_PAGES.includes(currentPage);
    return currentPage === page || isAccountSettingsPage ? css.currentPage : null;
  };

  const profileMenu = authenticatedOnClientSide && currentUser ? (
    <Menu>
      <MenuLabel className={css.profileMenuLabel} isOpenClassName={css.profileMenuIsOpen}>
        <Avatar className={css.avatar} user={currentUser} disableProfileLink />
      </MenuLabel>
      <MenuContent className={css.profileMenuContent}>
        <MenuItem key="ProfilePage">
          <NamedLink
            className={classNames(css.profileSettingsLink, currentPageClass('ProfilePage'))}
            name="ProfilePage"
            params={{ id: currentUser.id.uuid }}

          >
            <span className={css.menuItemBorder} />
            <FormattedMessage id="TopbarDesktop.profileSettingsLink" />
          </NamedLink>
        </MenuItem>
        <MenuItem key="InboxPage">
          <NamedLink
            className={classNames(css.yourListingsLink, currentPageClass('InboxPage'))}
            name="InboxPage"
            params={{ tab: 'demandes-en-cours' }}
          >
            <span className={css.menuItemBorder} />
            <FormattedMessage id="TopbarDesktop.inbox" />
          </NamedLink>
        </MenuItem>
        {
          currentUser.attributes.profile.publicData.isOwner ?
            <MenuItem key="ManageListingsPage">
              <NamedLink
                className={classNames(css.yourListingsLink, currentPageClass('ManageListingsPage'))}
                name="ManageListingsPage"
              >
                <span className={css.menuItemBorder} />
                <FormattedMessage id="TopbarDesktop.yourListingsLink" />
              </NamedLink>
            </MenuItem>
            : <MenuItem key="ManageListingsPage"><span></span></MenuItem>
        }

        <MenuItem key="BookingListingsPage">
          <NamedLink
            className={classNames(css.yourListingsLink, currentPageClass('BookingListingsPage'))}
            name="BookingListingsPage"
            params={{ tab: "attente" }}
          >
            <span className={css.menuItemBorder} />
            <span style={{ position: 'relative' }}>
              <FormattedMessage id="TopbarDesktop.booking" />
              {notificationBooking}
            </span>

          </NamedLink>
        </MenuItem>
        <MenuItem key="AccountSettingsPage">
          <NamedLink
            className={classNames(css.yourListingsLink, currentPageClass('AccountSettingsPage'))}
            name="AccountSettingsPage"
          >
            <span className={css.menuItemBorder} />
            <FormattedMessage id="TopbarDesktop.accountSettingsLink" />
          </NamedLink>
        </MenuItem>
        <MenuItem key="logout">
          <InlineTextButton rootClassName={css.logoutButton} onClick={onLogout}>
            <span className={css.menuItemBorder} />
            <FormattedMessage id="TopbarDesktop.logout" />
          </InlineTextButton>
        </MenuItem>
      </MenuContent>
    </Menu>
  ) : null;

  const signupLink = isAuthenticatedOrJustHydrated ? null : (
    <NamedLink name="SignupPage" className={css.signupLink}>
      <span className={css.signup}>
        <FormattedMessage id="TopbarDesktop.signup" />
      </span>
    </NamedLink>
  );

  const loginLink = isAuthenticatedOrJustHydrated ? null : (
    <NamedLink name="LoginPage" className={css.loginLink}>
      <span className={css.login}>
        <FormattedMessage id="TopbarDesktop.login" />
      </span>
    </NamedLink>
  );
  // @TODO hide payment
  return (
    <nav className={classes}>
      <div className={css.rightSide}>
        <Drawer
          isAuthenticatedOrJustHydrated={isAuthenticatedOrJustHydrated}
          onLogout={onLogout}
          user={currentUser}
          currentPage={currentPage}
          isMobileLayout={isMobileLayout}
          showAddListing={showAddListing}
          notificationBooking={notificationBooking}
          transactionsCount={transactions ? transactions.length : 0}
          mounted={mounted}
        />
        <NamedLink className={css.logoLink} name="LandingPage">
          <Logo
            format={isMobileLayout ? "desktop" : "desktop"}
            className={isMobileLayout ? css.logoDesktopForMobile : css.logo}
            alt={intl.formatMessage({ id: 'TopbarDesktop.logo' })}
          />
        </NamedLink>
      </div>
      {isMobileLayout ?
        <div className={css.leftSide}>
          {profileMenu}
        </div> :
        <div className={css.leftSide}>
          {profileMenu}
          {
            showAddListing ?
              <NamedLink
                className={css.createListingLink}
                name="NewListingPage"
              >
                <span className={css.createListing}>
                  <FormattedMessage id="TopbarDesktop.createListing" />
                </span>
              </NamedLink>
              : <NamedLink
                className={css.showListingLink}
                name="SearchPage"
                to={{ search: "?pub_category=garden_rent" }}
              >
                <span className={css.createListing}>
                  <FormattedMessage id="SectionHero.browseButton" />
                </span>
              </NamedLink>
          }

          {!isMobileLayout && signupLink}
          {!isMobileLayout && loginLink}
        </div>
      }
    </nav>
  );
};

const { bool, func, object, number, string } = PropTypes;

TopbarDesktop.defaultProps = {
  rootClassName: null,
  className: null,
  currentUser: null,
  currentPage: null,
  notificationCount: 0,
};

TopbarDesktop.propTypes = {
  rootClassName: string,
  className: string,
  currentUserHasListings: bool.isRequired,
  currentUser: propTypes.currentUser,
  currentPage: string,
  isAuthenticated: bool.isRequired,
  onLogout: func.isRequired,
  notificationCount: number,
  intl: intlShape.isRequired,
};

export default TopbarDesktop;
